import React, {memo, useEffect, useState} from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {Tooltip} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import Grid from "@mui/material/Grid";
import {toast} from "react-toastify";
import MenuItem from "@mui/material/MenuItem";
import Api from "../../utils/api";
import {roleAction, ticketAction, userAction} from "../../actions";
import {connect} from "react-redux";
import Autocomplete from "@mui/lab/Autocomplete";
import { UserAutocomplete } from './../../components'
const Create = memo((props) => {

    const { treeReducer, fetchTickets } = props;

    const initStat = {}


    const [form, setForm] = useState(initStat);

    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);


    const handleChangeElement = (event) => {
        let frm = {...form};
        frm[event.target.name] = event.target.value;
        setForm(frm);
    };


    const handleChangeElementWithAutoComplete = (name, value) => {
        let frm = {...form};
        frm[name] = value;
        setForm(frm);
    };



    const handleSubmit = (event) => {
        event.preventDefault();

        setLoading(true);

        new Api().post('/tickets', form).then((response) => {
            if (typeof response !== "undefined") {
                if (response.status) {
                    setOpen(false);
                    setForm(initStat);
                    fetchTickets();
                } else {
                    toast.error(response.msg);
                }
            }
            setLoading(false);
        })

    }


    return (
        <div>
            <Tooltip title="افزودن">
                <IconButton onClick={() => setOpen(true)}>
                    <AddCircleOutlineIcon />
                </IconButton>
            </Tooltip>
            <Dialog fullWidth={true} open={open} aria-labelledby="form-dialog-title">
                <form dir='rtl' onSubmit={handleSubmit}>
                    <DialogTitle id="form-dialog-title">تیکت جدید</DialogTitle>
                    <DialogContent>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <UserAutocomplete onChange={(value) => handleChangeElementWithAutoComplete('created_by', value)}/>
                            </Grid>
                            <Grid item xs={12}>
                                <Autocomplete
                                    onChange={((event, value) => handleChangeElementWithAutoComplete('category_id', (value ? value.id : '') ))}
                                    options={treeReducer.nodes}
                                    getOptionLabel={(option) => option.title}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            fullWidth
                                            name='category_id'
                                            margin={"dense"}
                                            label="بخش"
                                            variant="outlined"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    }
                                />
                            </Grid>
                            <Grid item xs={12} >
                                <TextField
                                    label="عنوان"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='title'
                                    onChange={handleChangeElement}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button color="primary" onClick={() => setOpen(false)}>
                            انصراف
                        </Button>
                        <Button disabled={loading} color="primary" autoFocus type='submit'>
                            ارسال اطلاعات
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        </div>
    );

})


const mapStateToProps = state => ({
    treeReducer: state.treeReducer
});

const mapDispatchToProps = (dispatch) => ({
    fetchTickets: () => {
        dispatch(ticketAction.tickets())
    }
});



export default connect(mapStateToProps, mapDispatchToProps)(Create)